import { css } from '@emotion/core';
import { useTheme } from 'emotion-theming';
import { Link } from 'react-router-dom';

import HamburgerNavigation from '../../components/HamburgerNavigation/HamburgerNavigation';
import NavigationTabs from '../../constants/NavigationTabs';
import mobileContainerHeightCSS from '../../constants/mobileContainerHeightCSS';
import StudiesContent from './StudiesContent';
import HelpIcon from '../../components/HelpIcon';
import useMessageService from '../../services/i18n/useMessageService';
import { AuthenticatedPaths } from '../../constants/Paths';
import getTargetAttribute from '../../services/getTargetAttribute';

export default function StudiesLayoutMobile() {
    const { grayLighter, blue, orange } = useTheme();

    const [[helpTextLabel, helpLinkLabel, helpLinkAriaLabel], messagesLoading] = useMessageService([
        'home.studies_help_message',
        'home.studies_help_link',
        'home.studies_help_message_aria_label',
    ]);

    /**
     * In case the {0} in `helpTextLabel` is not at the end of the message,
     * Separate and render the halves before and after the {0} token
     */
    const indexOfToken = helpTextLabel?.indexOf('{0}');
    const helpTextLabelWithoutToken = helpTextLabel?.replace('{0}', '  ');
    const helpTextFirstHalf = helpTextLabelWithoutToken?.slice(0, indexOfToken);
    const helpTextSecondHalf = helpTextLabelWithoutToken?.slice(indexOfToken);
    const studiesHelpIconCSS = css`
        position: absolute;
        width: 2rem;
        height: 2rem;
        padding-left: 0.3333rem;

        & > svg:first-of-type {
            width: 2rem;
            height: 2rem;
        }
    `;

    const studiesHelpIconTextCSS = css`
        font-size: 1.1666rem;
        color: ${grayLighter};
    `;

    const studiesHelpIconLinkCSS = css`
        font-size: 1.1666rem;
        text-decoration: none;
        transition: color 300ms;
        color: ${blue};

        &:hover,
        &:focus {
            color: ${orange};
            outline: none;
        }
    `;

    const headerContent = () => {
        if (messagesLoading) {
            return null;
        }

        return (
            <HelpIcon
                ariaLabel={helpLinkAriaLabel}
                helpIconCSS={studiesHelpIconCSS}
                message={
                    <span
                        css={studiesHelpIconTextCSS}
                        data-target={getTargetAttribute('studies-help-message')}
                    >
                        {helpTextFirstHalf}
                        <Link
                            css={studiesHelpIconLinkCSS}
                            to={AuthenticatedPaths.SYSTEMS}
                            data-target={getTargetAttribute('studies-help-systems-link')}
                        >
                            {helpLinkLabel}
                        </Link>
                        {helpTextSecondHalf}
                    </span>
                }
            />
        );
    };

    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                width: 100vw;
                overflow: scroll;
                ${mobileContainerHeightCSS}
            `}
        >
            <HamburgerNavigation
                headerContent={headerContent()}
                selectedTab={NavigationTabs.STUDIES}
            />
            <div
                css={css`
                    padding: 2rem;
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                `}
            >
                <StudiesContent />
            </div>
        </div>
    );
}
